import { render, staticRenderFns } from "./DataListStaffHasFormations.vue?vue&type=template&id=6e9f4f8a&"
import script from "./DataListStaffHasFormations.vue?vue&type=script&lang=js&"
export * from "./DataListStaffHasFormations.vue?vue&type=script&lang=js&"
import style0 from "./DataListStaffHasFormations.vue?vue&type=style&index=0&id=6e9f4f8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports